export const TextStyle = {
  baseStyle: {
    fontFamily: "'Poppins', 'Inter', 'Helvetica Neue', Arial, sans-serif",
    fontWeight: 400,
    color: 'brand.text',
  },
  variants: {
    // Semantic
    body: { fontSize: '16px', color: 'brand.text', lineHeight: 1.6 },
    secondary: { fontSize: '14px', color: 'brand.text.secondary', lineHeight: 1.5 },
    muted: { fontSize: '13px', color: 'brand.text.muted' },
    label: { fontSize: '14px', fontWeight: 500, color: 'brand.text' },
    helper: { fontSize: '13px', color: 'brand.text.secondary', lineHeight: 1.4 },
    stepIndicator: { fontSize: '13px', fontWeight: 600, color: 'accent.600' },

    // Legacy (kept during migration)
    link: { fontSize: 16, color: 'brand.primary', lineHeight: 1.2, textTransform: 'none' },
    contentHeaderResume: { fontSize: 14, paddingLeft: [0, 0, '64px'], textTransform: 'none' },
    contentHeaderSection: { color: 'accent.600', fontSize: 14, fontWeight: 600, textTransform: 'none' },
    linkIcon: { color: 'brand.primary', fontSize: 14, fontWeight: 500 },
    sectionText: { fontSize: 16, fontWeight: 500, color: 'brand.text' },
    companyName: { fontSize: '16px', fontWeight: 400, textTransform: 'uppercase' },
    errorMessage: { color: 'red.600', fontSize: '14px', fontWeight: 600 },
    instructions: { fontSize: '14px', color: 'brand.text.secondary', fontWeight: 400, lineHeight: 1.4, paddingBottom: 1 },
    t24: { fontSize: 24 },
    t18: { fontSize: 18 },
    t16: { fontSize: 16 },
    t14: { fontSize: 14 },
    t12: { fontSize: 12 },
    o16: { fontSize: 16, fontWeight: 600, color: 'accent.600' },
    o14: { fontSize: 14, fontWeight: 600, color: 'accent.600' },
    o10: { fontSize: 10, fontWeight: 600, color: 'accent.600' },
  },
};
